import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteAccount from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
const DeleteAccountContainer = (props) => {
   const { makeApiRequest } = useApiRequest()
  const navigate=useNavigate()
  const [logoutModal, setLogutModal] = useState(false);
  const [reason,setReason]=useState(null)

useEffect(()=>{
  
  
},[])
const UserJWTAuth = localStorage.getItem('UserJWTAuth');
useEffect(()=>{
 
 //console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
 if(!UserJWTAuth){
  localStorage.setItem("enteryUrl",'/deleteaccount')
   navigate('/')
 }
},[])

useEffect(()=>{
 
  //console.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
  if(localStorage.getItem('Guest_clientId')){
    //navigate('/login')
  }
 },[])
 
//





 









const handleErrordeleteAccountApi =(error)=>{
  //console.log("khan handleErrorVmInventory", error.response.data.status.code);
  if(error.response.status==401|| error.response.status==403){

    //console.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
     // navigate("/login");
}
else{ toast.error(`${error&&error.response&&error.response.data&&error.response.data.status}`, {
  position: "top-right",
  autoClose: 1000,
});
}
  
  //setLoader(false)
  
}

const handleResponsedeleteAccountApi =(res)=>{
 setLogutModal(false)
 toast.success(`sucess`, {
    position: "top-right",
    autoClose: 1000,
  });
  //setLoader(false)
  //setLoader(false)
  //localStorage.removeItem('UserJWTAuth')
  navigate('/profile')
}

const deleteAccountApi = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");




    makeApiRequest({
        url: `https://api-prod.daalchini.co.in/auth/user/request/delete`,
     method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{
    
        "reason": reason


      },
      handleSuccess: (res) => handleResponsedeleteAccountApi(res),
      handleError:(error)=> handleErrordeleteAccountApi(error),
    });

};













return(
    <DeleteAccount
    deleteAccountApi={deleteAccountApi}
    logoutModal={logoutModal}
    setLogutModal={setLogutModal}
    setReason={setReason}
 />
)


}




  export default  DeleteAccountContainer